type AlarmMomentsNavigationButtonProps = {
  readonly text: string
  readonly isSelected?: boolean
  readonly onClick: () => void
}

export function AlarmMomentsNavigationButton({
  text,
  isSelected = false,
  onClick
}: AlarmMomentsNavigationButtonProps) {
  const isSelectedClasses = isSelected
    ? 'bg-complementary-blue-100 text-white'
    : 'bg-white text-neutral-black'

  return (
    <button
      className={`${isSelectedClasses} text-base border-complementary-blue-100 flex min-w-fit cursor-pointer items-center justify-center rounded-full border border-solid p-2 px-4 transition duration-300`}
      data-component="AlarmMomentsNavigationButton"
      onClick={onClick}
    >
      {text}
    </button>
  )
}
